
    <app-kontable
      title="{{ 'promotion.messagesTitle' | translate }}"
      *ngIf="!show"
      [columns]="[
        'id',
        'code',
        'type_message_id',
        'description'
      ]"
      [titles]="[
        '#',
        'promotion.code',
        'promotion.typeMessage',
        'promotion.description'
      ]"
      [service]="svcMessage"
      [paginationType]="paginationType"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      [name]="'promotion.messageTable'">
    </app-kontable>
    <kv-promo-message-detail
      *ngIf="show"
      [shortInsert]="shortInsert"
      [titlePage]="titlePage"
      (hide)="editMessage = null; toggleShow()"
      [wizards]="wizards"
      [discountTypes]="discountTypes"
      [messagesTypes]="messagesTypes"
      [barCodes]="barCodes"
      [clusters]="clusters"
      [templates]="templates"
      [editMessage]="editMessage"
      [touchPoints]="touchPoints"
      [layouts]="layouts">
    </kv-promo-message-detail>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/message/message.component.ts.MessageComponent.html